/**
 * @generated SignedSource<<1e97e9e942109ae1ef7a3edfd5c074ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ControlCommunityRedirectPageQuery$variables = {
  id: string;
};
export type ControlCommunityRedirectPageQuery$data = {
  readonly community: {
    readonly controlAccessUrl: string;
    readonly id: string;
  };
};
export type ControlCommunityRedirectPageQuery = {
  response: ControlCommunityRedirectPageQuery$data;
  variables: ControlCommunityRedirectPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": "community",
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ControlOrganization",
    "kind": "LinkedField",
    "name": "controlGetCommunity",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "controlAccessUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ControlCommunityRedirectPageQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ControlCommunityRedirectPageQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "504b14f71be59e0787fd9bf10a83e385",
    "id": null,
    "metadata": {},
    "name": "ControlCommunityRedirectPageQuery",
    "operationKind": "query",
    "text": "query ControlCommunityRedirectPageQuery(\n  $id: ID!\n) {\n  community: controlGetCommunity(id: $id) {\n    id\n    controlAccessUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "b2b7423bd024e5f7b7af139b0d174f1b";

export default node;
